/**
 * @function to call price catalog api
 * @param reqObj 
 * @returns fee, fx, receiveAmount and selectedFundsOut
 */
var triggerPriceCatalog = (reqObj, isCurrencyConverterUpdated,isbestfxRequired) => {
    try {

        const getSenderConfig = () => (
                WuAmerigoConfigs.isAmerigo() ? 
                {
                    client: WuAmerigoConfigs.getClient(reqObj.funds_in === 'CA'? 'RETAIL': 'DIGITAL'),
                    channel: 'WRET',
                    funds_in: '*'
                } : {
                    client: reqObj.client || 'WUCOM',
                    channel: reqObj.channel || 'WWEB',
                    funds_in: reqObj.funds_in || "*"
        });

         // Fetching customer account number
         const customerId = window.sessionStorage.getItem('AccountNumber');
         const addVisitorAttr = () => (
            customerId &&
            { 
                visitor: {
                    customer_id: customerId
                }
            }); 
         //

        const reqPayload = { // TODO: Add realtime session id in the payload
            header_request: {
                version: "0.5",
                request_type: "PRICECATALOG"
            },
            sender: {
                ...getSenderConfig(),
                curr_iso3: reqObj.currency.toUpperCase(),
                cty_iso2_ext: reqObj.country.toUpperCase(),
                ... (!reqObj.receiveAmount && { send_amount: reqObj.sendAmount })
            },
            receiver: {
                curr_iso3: reqObj.sendToCurrency.toUpperCase(),
                cty_iso2_ext: reqObj.sendToCountry.toUpperCase(),
                cty_iso2: reqObj.sendToCountry.toUpperCase(),
                ... (reqObj.receiveAmount && { receive_amount: reqObj.receiveAmount })
            },
            ...addVisitorAttr()
        }
        const campaignName = sessionStorage.getItem('serverSidePromoCampaignName') || sessionStorage.getItem('promoPricingCampaignNameUrlParam')
            || sessionStorage.getItem('promoPricingCampaignName')
        if (campaignName || reqObj.subscriptionId) {
            reqPayload.campaign = {
                campaign_name: campaignName || undefined,
                subscriptionId: reqObj.subscriptionId
            }
        }

        const filterResponse = (serviceGroups, fundOut) => {
            const filteredServiceGrp = serviceGroups.find(ele => ele.fund_out_mnem === fundOut && ele.pay_groups[0])
            if (filteredServiceGrp) {
                return {
                    fx: filteredServiceGrp.pay_groups[0].fx_rate,
                    fee: filteredServiceGrp.pay_groups[0].gross_fee,
                    receiveAmount: filteredServiceGrp.pay_groups[0].receive_amount,
                    sendAmount: reqObj.receiveAmount ? filteredServiceGrp.pay_groups[0].send_amount : 0,
                    selectedFundsOut: filteredServiceGrp.fund_out_mnem,
                    strike_fx_rate: filteredServiceGrp.pay_groups[0].strike_fx_rate,
                    selectedFundsIn: filteredServiceGrp.pay_groups[0].fund_in,
                    strike_fee: filteredServiceGrp.pay_groups[0].strike_gross_fee,
                    strikeReceiveAmount: (filteredServiceGrp.pay_groups[0].strike_fx_rate && reqObj.sendAmount) && filteredServiceGrp.pay_groups[0].strike_fx_rate * reqObj.sendAmount,
                    serviceCode: filteredServiceGrp.service,
                    fee_percentage: filteredServiceGrp.pay_groups[0].fee_percentage,
                    gross_amount: filteredServiceGrp.pay_groups[0].gross_amount
                }
            } else if (!filteredServiceGrp) {
                for (let i = 0; i < serviceGroups.length; i++) {
                    /// Mobile Wallet fund-out memonic MB & DC we get 800 fund_out                  
                    if ((serviceGroups[i]['fund_out'] === '800') && (fundOut === 'MB' || fundOut === 'DC') &&
                        (CloudPayOut[fundOut] === PayOutCodeNames[serviceGroups[i]['fund_out']])) {
                        return {
                            fx: serviceGroups[i].pay_groups[0].fx_rate,
                            fee: serviceGroups[i].pay_groups[0].gross_fee,
                            receiveAmount: serviceGroups[i].pay_groups[0].receive_amount,
                            sendAmount: reqObj.receiveAmount ? serviceGroups[i].pay_groups[0].send_amount : 0,
                            selectedFundsOut: serviceGroups[i].fund_out_mnem,
                            strike_fx_rate: serviceGroups[i].pay_groups[0].strike_fx_rate,
                            selectedFundsIn: serviceGroups[i].pay_groups[0].fund_in,
                            strike_fee: serviceGroups[i].pay_groups[0].strike_gross_fee,
                            strikeReceiveAmount: (serviceGroups[i].pay_groups[0].strike_fx_rate && reqObj.sendAmount) && serviceGroups[i].pay_groups[0].strike_fx_rate * reqObj.sendAmount,
                            serviceCode: serviceGroups[i].service,
                            fee_percentage: serviceGroups[i].pay_groups[0].fee_percentage,
                            gross_amount: serviceGroups[i].pay_groups[0].gross_amount
                        }
                    }
                } // End For Loop
            } /// End If
        }

        const findBestFxServiceAndGroup = (bestFxGroup, groups) => {
            const bestFxServices = bestFxGroup?.products || bestFxGroup?.services
            let bestFxService
            let serviceGroup
            for(let i = 0; i < bestFxServices.length; i++) {
                bestFxService = bestFxServices[i];
                serviceGroup = groups?.find(bestpayout => (bestpayout.service === bestFxService.fund_out) || (bestpayout.service === bestFxService.pay_out) || (bestpayout.service === bestFxService.service) );
                if(serviceGroup) break;
            }
            return [bestFxService, serviceGroup];
        }

        const bestFxResponse = (serviceGroups, groups) => {
            const bestFxGroup = serviceGroups.find(group => reqObj?.country?.toUpperCase() === 'US' ? group.type === 'best-rate-fee' : group.type === 'bestfx');
            if (bestFxGroup) {
                const [bestFxService, serviceGroup] = findBestFxServiceAndGroup(bestFxGroup, groups);
                if (!bestFxService || !serviceGroup) {
                    return null;
                }
                if(serviceGroup){
                    const serviceGrossFee = serviceGroup.pay_groups.find(fundsIn => (fundsIn.fund_in === bestFxService.pay_in) || (fundsIn.fund_in === bestFxService.fund_in));
                    bestFxService.gross_fee = serviceGrossFee.base_fee;
                    bestFxService.strike_gross_fee =  serviceGrossFee.strike_gross_fee;                   
                    bestFxService.fee_percentage =  serviceGrossFee.fee_percentage;                   
                    bestFxService.gross_amount =  serviceGrossFee.gross_amount;                   
                }               
                if (bestFxService) {                            
                    const receiveAmt = calcAmt(bestFxService, reqObj, false);
                    const strikeReceiveAmt = calcAmt(bestFxService, reqObj, true);
                    return {
                        fx: bestFxService.fx_rate,
                        strike_fx_rate: bestFxService.strike_fx_rate,
                        selectedFundsOut: bestFxService.fund_out_mnem || bestFxService.pay_out_mnem,
                        selectedFundsIn: bestFxService.fund_in || bestFxService.pay_in,
                        strike_fee: bestFxService.strike_gross_fee,
                        fee: bestFxService.gross_fee,
                        receiveAmount: receiveAmt,
                        sendAmount: reqObj.receiveAmount ? serviceGroup.pay_groups[0].send_amount : 0,
                        strikeReceiveAmount: strikeReceiveAmt,
                        payIn: bestFxService.fund_in || bestFxService.pay_in,
                        serviceCode: serviceGroup.service,
                        fee_percentage: bestFxService.fee_percentage,
                        gross_amount: bestFxService.gross_amount
                    };
                } 
            }
        } 

        const host = getHttpRequestUrl(reqObj.host, reqObj.country.toLowerCase(), isCurrencyConverterUpdated);

        const initApi = response => {
            const url = `${host}wuconnect/prices/catalog`
            let filteredResp
            if(response.categories && response.categories.length > 0 && isbestfxRequired){
                const serviceGroups = response.categories;
                filteredResp = bestFxResponse(serviceGroups, response.services_groups); 
            } 
            if (!filteredResp && response.services_groups && response.services_groups.length > 0) {
                const serviceGroups = response.services_groups
                if (reqObj.funds_in && reqObj.fund_out_mnem) {
                    filteredResp = filterResponse(serviceGroups, reqObj.fund_out_mnem)
                    if (!filteredResp) filteredResp = filterResponse(serviceGroups, 'MM') // default funds out mnemonic
                } else {
                    const firstPaygroup = serviceGroups[0].pay_groups
                    if (firstPaygroup && firstPaygroup[0]) {
                        filteredResp = {
                            fx: firstPaygroup[0].fx_rate,
                            fee: firstPaygroup[0].gross_fee,
                            receiveAmount: firstPaygroup[0].receive_amount,
                            sendAmount: reqObj.receiveAmount ? firstPaygroup[0].send_amount : 0,
                            selectedFundsOut: serviceGroups[0].fund_out_mnem,
                            selectedFundsIn: firstPaygroup[0].fund_in,
                            serviceCode: serviceGroups[0].service,
                            fee_percentage: firstPaygroup[0].fee_percentage,
                            gross_amount: firstPaygroup[0].gross_amount
                        }
                    }
                }
            }
            return filteredResp || {
                fx: null,
                fee: null,
                receiveAmount: 0,
                sendAmount: 0,
                strikeReceiveAmount:0,
                strike_fx_rate:0,
                strike_fee:0,
                payIn:null,
                serviceCode:null,
                fee_percentage: 0,
                gross_amount: 0
            };
        }
        return {
            reqPayload,
            url: `${host}wuconnect/prices/catalog`,
            initApi

        }
    } catch (e) {
        console.warn('Error in catalog service', e)
    }
}

const dataCatalogProduct = (
  isCurrencyConverterUpdated,
  country,
  language,
  reqProductData,
  priceCatalogConfig,
  getBestFxWithoutFiFo,
  destinationCurrency
) => {
    const isR4Country = getR4Country();
  if (isR4Country && !isCurrencyConverterUpdated) {
    return triggerRouterCreateSession(country, language).then(
      ({ sessionId, encryptedSessionId }) => {
          const r4_catalog_data = triggerProductApi(
            sessionId,
            reqProductData.country,
            reqProductData.sendToCountry,
            reqProductData.language,
            reqProductData.sendAmount,
            reqProductData.fund_in,
            reqProductData.fund_out_mnem,
            getBestFxWithoutFiFo,
            destinationCurrency,
            reqProductData.channel,
            reqProductData.client
          )
          customEventListnenerData('catalogFifoEvent',r4_catalog_data)
          return Promise.resolve(r4_catalog_data)
      }
    );
  } else if (isCurrencyConverterUpdated) {
    const wu_device_id = CookieService.getCookie("wu_device_id");
    let userIdentity = CookieService.getCookie("userIdentity");
    if (!userIdentity) {
      CookieService.setCookie(
        "userIdentity",
        "newCustomer",
        365,
        location.pathname
      );
    }
    const headersCatalogApi = {
      Cookie: "userIdentity=" + userIdentity + "; wu_device_id=" + wu_device_id,
    };
    return httpRequest
      .post(
        priceCatalogConfig.url,
        priceCatalogConfig.reqPayload,
        headersCatalogApi
      )
      .catch((error) => {
        toggleClass &&
          this.spinnerEl &&
          toggleClass(this.spinnerEl, "d-flex", "d-none");
        console.log("error", error);
      });
  } else {
    const r3_catalog_data = httpRequest.post(
      priceCatalogConfig.url,
      priceCatalogConfig.reqPayload
    );
    customEventListnenerData('catalogFifoEvent',r3_catalog_data)
    return r3_catalog_data;
  }
};